import { render, staticRenderFns } from "./EventTypePartPage.vue?vue&type=template&id=15ce1846&"
import script from "./EventTypePartPage.vue?vue&type=script&lang=js&"
export * from "./EventTypePartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports